module.exports = __webpack_public_path__ + "img/x13.04ab5e6f.jpg";